module.exports = global["jQuery"] = require("-!/Users/chris/Projects/99designs/start/assets/node_modules/expose-loader/index.js?$!/Users/chris/Projects/99designs/start/assets/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js
// module id = 607
// module chunks = 0